import React , {useCallback, useRef, useEffect, useState} from 'react'
import { Modal, Button } from 'semantic-ui-react';
import PropTypes from "prop-types";
import './styles.css'

const IFrameDialog = ({onSave, onClose, title, style, src, showSave, customActions,  ...rest}) => {
    const iframeRef = useRef(null)
    const selfRef = useRef(null)
    const [isSaving, setIsSaving] = useState(false)
    
    useEffect(()=>{
        window.addEventListener("message", function (event) {
            if (event.data === "CompleteSaveAction") {
                setIsSaving(false)
                if (onSave) {
                    onSave()
                    selfRef.current.handleClose(event)
                }
            } else if (event.data === "FailSaveAction") {
                setIsSaving(false)
                if (onSave) {
                    onSave()
                }
            }
        });
    }, [selfRef])

    const saveAction = useCallback(()=>{
        if (iframeRef.current){
            setIsSaving(true)
            iframeRef.current.contentWindow.postMessage("PerformSaveAction", "*");
        }
    }, [iframeRef])

    const closeAction = useCallback((e)=>{
       selfRef.current.handleClose(e)
       if (onClose) onClose()
    }, [selfRef])
    
    return (
        <Modal 
            dimmer="inverted"
            ref={selfRef}
            className="IFrameDialog"
            {...rest}
        >
            <Modal.Header>{title}</Modal.Header>
            <Modal.Content>
                <iframe style={style} ref={iframeRef} src={src + (src.includes("?")?"&":"?") + "IFrameDialog"} ></iframe>
            </Modal.Content>
            <Modal.Actions>         
                <Button disabled={isSaving} negative size="small" onClick={closeAction}>Close</Button>
                {customActions}
                {
                    showSave &&
                    <Button disabled={isSaving} loading={isSaving} positive size="small" onClick={saveAction}>Save</Button>
                }       
            </Modal.Actions>
        </Modal>
    )
}
IFrameDialog.propTypes = {
    title: PropTypes.string,
    trigger: PropTypes.node,
    src: PropTypes.string,
    showSave: PropTypes.bool,
    size: PropTypes.oneOf(['mini','tiny','small','large','fullscreen']),
    style: PropTypes.object,
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    customActions: PropTypes.any,
}
export default IFrameDialog